<div class="staking-wrapper">
  <div class="row">
    <div class="col-12 staking-banner">
      <img
        src="/assets/images/banner2.jpg"
        style="width: 100%;"
      >
    </div>
    <div class="col-12 staking-title">{{'staking.stakeTokenTitle' | transloco: {tokenName: tokenName} }}</div>
    <div class="col-12 staking-desc">
      <p>{{'nft-staking.desc' | transloco}}</p>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12 col-md-4">
      <div class="centered-text-wrapper">
        <div class="balance">{{'staking.available' | transloco}}</div>
        <div class="gradient-text">{{tokenService.tokenAmount$ | async | valueToDecimal}}</div>
        <div class="deemphasized-text">{{tokenService.tokenAmount$ | async | convertToUsd | valueToDecimal}}
          USD
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-md-4">
      <div class="centered-text-wrapper">
        <div class="balance">{{'staking.stakedBalance' | transloco}}</div>
        <div class="gradient-text">{{totalAmount | valueToDecimal}}</div>
        <div class="deemphasized-text">{{totalAmount | convertToUsd | valueToDecimal}}
          USD
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-md-4">
      <div class="centered-text-wrapper gradient">
        <div class="balance">{{'staking.totalRewards' | transloco}}</div>
        <div class="value">{{totalRewards | valueToDecimal}}</div>
        <div class="deemphasized-text">{{totalRewards | convertToUsd | valueToDecimal}}
          USD
        </div>
      </div>
    </div>
  </div>
  <div class="row text-wrapper staking-action">
    <div class="col-12 gradient-wrapper">
      <div [ngClass]="{'d-flex justify-content-between': !isMobile}">
        <div class="vertical-align">{{'staking.nativeStaking' | transloco: {tokenName: tokenName} }}</div>
        <div>
          <div class="amount">{{'nft-staking.stakingApr' | transloco}}
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <form [formGroup]="form">
        <div class="row">
          <div class="col-12 tokens">
            <div [ngClass]="{'d-flex': !isMobile}">
              <div class="d-flex align-items-center">
                <div class="label">{{'staking.token' | transloco: {tokenName: tokenName} }}</div>
              </div>
              <div class="flex-grow-1 dark-wrapper d-flex justify-content-between">
                <div class="input-wrapper">
                  <div class="form-group">
                    <input
                      type="text"
                      formControlName="available"
                    >
                  </div>
                </div>
                <div class="call-to-action-section">
                  <button
                    class="btn border-button stake-all-btn text-truncate"
                    (click)="stakeAll()"
                  >{{'staking.stakeAll' | transloco}}</button>
                  <div
                    class="btn-group"
                    dropdown
                    placement="bottom left"
                  >
                    <button
                      id="button-basic"
                      dropdownToggle
                      type="button"
                      class="btn plain-button stake-btn text-truncate dropdown-toggle"
                      aria-controls="dropdown-basic"
                    >
                      <span
                        *ngIf="staking$ | async"
                        class="spinner-border"
                        role="status"
                      >
                        <span class="sr-only"></span>
                      </span>
                      {{'staking.stake' | transloco}}<span class="caret"></span>
                    </button>
                    <ul
                      id="dropdown-basic"
                      *dropdownMenu
                      class="dropdown-menu dropdown-menu-right"
                      role="menu"
                      aria-labelledby="button-basic"
                      style="width: unset;"
                    >
                      <ng-container *ngFor="let lock of lockFor">
                        <li role="menuitem">
                          <a
                            class="dropdown-item"
                            (click)="stake(lock)"
                          >{{('nft-staking.' + lock.toString()) | transloco:{value: calcUSDCforLock(lock).toFixed(2)}
                            }}</a>
                        </li>
                      </ng-container>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="col-12 text-start">
      <button
        class="btn need-more"
        (click)="openModal(template)"
      >{{'staking.needMore' | transloco: {tokenName: tokenName} }}</button>
    </div>
  </div>

  <div
    style="width: 100%; display: flex; justify-content: center; padding: 50px 0;"
    *ngIf="isLoading"
  >
    <div class="loader"></div>
  </div>

  <div
    *ngIf="stakingData"
    class="stake-images"
  >
    <div
      class="stake-item"
      *ngFor="let stake of stakingData; let i = index"
    >
      <img [src]="stake.image">

      <button
        class="btn plain-button unstake-btn text-truncate"
        [disabled]="(unstaking$ | async) || (isInFuture(stake.lockedUntil) )"
        (click)="unstake(stake.tokenId)"
      >

        <span
          *ngIf="unstaking$ | async"
          class="spinner-border"
          role="status"
        >
          <span class="sr-only"></span>
        </span>{{'staking.unStake' | transloco}}
      </button>
    </div>
  </div>

  <ng-template #finishedTemplate>
    <div class="gradient-text">{{'staking.completed' | transloco | uppercase}}</div>
  </ng-template>
</div>


<ng-template #template>
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{'staking.tokenModalTitle' | transloco: {tokenName: tokenName} }}</h4>
    <button
      type="button"
      class="btn close pull-right"
      aria-label="Close"
      (click)="modalRef.hide()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div
      class="modal-text-wrapper"
      *ngFor="let item of exchangeList"
    >
      <div
        class="d-flex justify-content-start"
        (click)="goToUrl(item.url)"
      >
        <div class="icon vertical-align">
          <img
            [src]="'../../assets/images/' + item.icon"
            alt="list-icon"
          >
        </div>
        <div>
          <div class="item-name">{{item.name}}</div>
          <div class="item-url">{{item.url.substr(0, item.url.indexOf('?')) }}</div>
        </div>
      </div>
    </div>
  </div>
</ng-template>


<app-terms-and-conditions></app-terms-and-conditions>
<div style="margin-bottom: 30px;"></div>

<a
  href="https://bit.ly/CrimsonHollow"
  target="_blank"
>
  <img
    src="/assets/images/banner.png"
    style="width: 100%; margin-bottom: 100px"
  >
</a>
